'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _item = require('./mock/item');

var _item2 = require('./remote/item');

var Item = {
    fetchItemsByIds: function fetchItemsByIds(params) {
        return __MOCK__ ? _item.ItemMock.fetchItemsByIds(params) : _item2.ItemRemote.fetchItemsByIds(params);
    },
    fetchItemShippingsByIds: _item2.ItemRemote.fetchItemShippingsByIds,
    fetchListingAgentsByIds: _item2.ItemRemote.fetchListingAgentsByIds
};

exports.default = Item;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/item.js
// module id = lSbF
// module chunks = 57